(() => {
  const modalSelector = 'quick-buy-modal';

  function variantMap(modal) {
    const node = modal.querySelector('[data-callea-variant-media-map]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('[CalleaDesign] Quick Buy variant media map is invalid.', error);
      return null;
    }
  }

  function selectedVariantId(modal) {
    return (
      modal.querySelector('form[id^="product-form-quick-buy-"] input[name="id"]')?.value ||
      modal.querySelector('input[name="id"]')?.value ||
      null
    );
  }

  function syncGallery(modal) {
    if (!(modal instanceof Element)) return;

    const gallery = modal.querySelector('product-gallery');
    const carousel = gallery?.querySelector('scroll-carousel');

    if (!gallery || !carousel) return;

    const map = variantMap(modal);
    const variantId = selectedVariantId(modal);
    const variantMedia = map && variantId ? map[String(variantId)] : null;

    let target = null;

    if (variantMedia?.media_id) {
      target = gallery.querySelector(
        `.product-gallery__media[data-media-id="${variantMedia.media_id}"]`
      );
    }

    if (!target) {
      target = gallery.querySelector('.product-gallery__media.is-initial');
    }

    if (!target && variantMedia?.position) {
      target = gallery.querySelectorAll('.product-gallery__media')[Number(variantMedia.position) - 1];
    }

    if (!target) return;

    if (target.hidden) target.hidden = false;

    const media = [...carousel.querySelectorAll('.product-gallery__media')];
    const visibleMedia = media.filter((item) => !item.hidden);
    let index = visibleMedia.indexOf(target);

    if (index < 0) index = media.indexOf(target);

    const dots = [...gallery.querySelectorAll('carousel-navigation button')].filter(
      (button) => !button.hidden
    );

    if (index >= 0 && dots[index]) {
      dots[index].click();
    }

    const targetMediaId = target.dataset.mediaId;
    if (targetMediaId) {
      const thumbnail = gallery.querySelector(
        `product-gallery-navigation [data-media-id="${targetMediaId}"]`
      );
      if (thumbnail && !thumbnail.hidden) {
        thumbnail.setAttribute('aria-current', 'true');
      }
    }

    media.forEach((item) => {
      item.classList.toggle('is-initial', item === target);
    });

    requestAnimationFrame(() => {
      if (typeof carousel.scrollTo === 'function') {
        carousel.scrollTo({
          left: target.offsetLeft,
          behavior: 'auto'
        });
      }
    });
  }

  function scheduleSync(modal) {
    [0, 80, 220, 500, 900, 1500].forEach((delay) => {
      window.setTimeout(() => syncGallery(modal), delay);
    });
  }

  document.addEventListener(
    'change',
    (event) => {
      const modal = event.target.closest?.(modalSelector);
      if (modal) scheduleSync(modal);
    },
    true
  );

  const startObserver = () => {
    const observer = new MutationObserver((mutations) => {
      const modals = new Set();

      for (const mutation of mutations) {
        for (const addedNode of mutation.addedNodes) {
          if (!(addedNode instanceof Element)) continue;

          if (addedNode.matches?.(modalSelector)) {
            modals.add(addedNode);
          }

          addedNode.querySelectorAll?.(modalSelector).forEach((modal) => modals.add(modal));

          const containingModal = addedNode.closest?.(modalSelector);
          if (containingModal) modals.add(containingModal);
        }
      }

      modals.forEach(scheduleSync);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.querySelectorAll(modalSelector).forEach(scheduleSync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();